import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { REACT_APP_ENVIRONMENT } from '@partsbadger/utils';

/**
 * Records route changes as Sentry breadcrumbs to show page sequence before errors.
 */
const SentryNavigationTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (REACT_APP_ENVIRONMENT !== 'production') {
            return;
        }

        Sentry.addBreadcrumb({
            category: 'navigation',
            message: `${location.pathname}${location.search}${location.hash}`,
            level: 'info',
        });
    }, [location.pathname, location.search, location.hash]);

    return null;
};

export default SentryNavigationTracker;
